var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Sur3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 83,
    viewBox: "0 0 80 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1887 24.7768C40.7273 20.4802 33.0939 24.9757 30.0849 27.7605C28.5728 29.1599 27.0266 34.3529 24.7461 38.6528C21.8955 44.0276 13.9313 50.441 20.5828 62.9726C27.2343 75.5043 42.4377 73.714 52.89 65.3596C63.3424 57.0052 66.193 39.6995 59.0664 36.7158C51.9398 33.7321 55.2655 30.1475 47.1887 24.7768Z",
    fill: "#CDE3BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5579 66.7418C48.251 57.8363 45.6469 46.0018 36.7414 40.3087C27.8359 34.6156 16.0014 37.2197 10.3083 46.1252C4.61517 55.0307 7.21932 66.8652 16.1248 72.5583C25.0303 78.2514 36.8648 75.6472 42.5579 66.7418Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M42.5579 66.7418C48.251 57.8363 45.6469 46.0018 36.7414 40.3087C27.8359 34.6156 16.0014 37.2197 10.3083 46.1252C4.61517 55.0307 7.21932 66.8652 16.1248 72.5583C25.0303 78.2514 36.8648 75.6472 42.5579 66.7418Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.793 40.0391V45.2503",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8867 42.8281V46.9262",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2734 40.7812V44.8752",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7852 42.8516V45.2387",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5479 37.419C27.1132 37.2582 25.6578 37.2541 24.2148 37.419V75.4356C25.6496 75.6047 27.1049 75.6047 28.5479 75.448V37.419Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5579 66.7418C48.251 57.8363 45.6469 46.0018 36.7414 40.3087C27.8359 34.6156 16.0014 37.2197 10.3083 46.1252C4.61517 55.0307 7.21932 66.8652 16.1248 72.5583C25.0303 78.2514 36.8648 75.6472 42.5579 66.7418Z",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4204 60.6567C46.7196 50.1671 39.2692 40.6105 28.7796 39.3114C18.29 38.0123 8.73339 45.4626 7.43428 55.9522C6.13517 66.4418 13.5855 75.9984 24.0751 77.2976C34.5647 78.5967 44.1213 71.1463 45.4204 60.6567Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M42.532 60.4115C43.6965 51.5184 37.4312 43.3651 28.5381 42.2006C19.645 41.0361 11.4917 47.3014 10.3272 56.1945C9.16275 65.0876 15.428 73.2409 24.3211 74.4054C33.2142 75.5698 41.3675 69.3046 42.532 60.4115Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M42.532 60.4115C43.6965 51.5184 37.4312 43.3651 28.5381 42.2006C19.645 41.0361 11.4917 47.3014 10.3272 56.1945C9.16275 65.0876 15.428 73.2409 24.3211 74.4054C33.2142 75.5698 41.3675 69.3046 42.532 60.4115Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.532 60.4115C43.6965 51.5184 37.4312 43.3651 28.5381 42.2006C19.645 41.0361 11.4917 47.3014 10.3272 56.1945C9.16275 65.0876 15.428 73.2409 24.3211 74.4054C33.2142 75.5698 41.3675 69.3046 42.532 60.4115Z",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3592 70.1951C29.2555 75.6743 19.0598 74.3592 13.5805 67.2555C11.3954 64.4231 10.2946 61.1001 10.2081 57.7812C10.0885 61.4217 11.181 65.124 13.5805 68.2326C19.0598 75.3363 29.2597 76.6514 36.3592 71.1722C40.6304 67.8781 42.8032 62.873 42.6712 57.8678C42.5146 62.5431 40.3501 67.1153 36.3592 70.1951Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6278 56.1056L19.8349 54.8757L18.7757 53.8361L19.9395 52.6503L20.9988 53.69L22.2464 52.4189L21.1871 51.3792L22.351 50.1934L23.4102 51.2331L24.6983 49.9208C28.1927 46.3606 31.5626 45.3875 35.5024 49.2544C39.4422 53.1214 38.4235 56.1134 35.5528 59.0381L34.5334 60.0767L30.826 56.4379L32.0736 55.1668C33.0497 54.1723 34.0688 53.0928 32.8831 51.929C31.6973 50.7651 30.5109 51.7208 29.4914 52.7594L27.2677 55.025L29.4715 57.1881L28.3077 58.3739L26.1039 56.2108L24.8562 57.4819L27.0601 59.645L25.8962 60.8308L23.6924 58.6677L21.5726 60.8274C20.429 61.9925 19.7048 63.113 20.8258 64.2133C21.9468 65.3136 23.0718 64.3381 24.0913 63.2995L24.9634 62.4109L28.6708 66.0497L28.1105 66.6205C25.2399 69.5452 22.0201 70.6656 18.1833 66.8997C14.3464 63.1338 15.2171 59.5805 18.6278 56.1056Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6395 56.9806L19.8466 55.7507L18.7874 54.7111L19.9513 53.5253L21.0105 54.565L22.2581 53.2939L21.1989 52.2542L22.3627 51.0684L23.4219 52.1081L24.71 50.7958C28.2044 47.2356 31.5743 46.2625 35.5141 50.1294C39.4539 53.9964 38.4352 56.9884 35.5645 59.9131L34.5451 60.9517L30.8377 57.3129L32.0853 56.0418C33.0615 55.0473 34.0805 53.9678 32.8948 52.804C31.709 51.6401 30.5226 52.5958 29.5032 53.6344L27.2794 55.9L29.4832 58.0631L28.3194 59.2489L26.1156 57.0858L24.868 58.3569L27.0718 60.52L25.9079 61.7058L23.7041 59.5427L21.5844 61.7024C20.4407 62.8675 19.7165 63.988 20.8375 65.0883C21.9586 66.1886 23.0835 65.2131 24.103 64.1745L24.9752 63.2859L28.6825 66.9247L28.1223 67.4955C25.2516 70.4202 22.0318 71.5406 18.195 67.7747C14.3582 64.0088 15.2288 60.4555 18.6395 56.9806Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.412283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5859 54.6328V57.3004",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1758 55.4922V59.284",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1226 44.6081C73.9765 40.4294 74.4772 28.7499 68.2409 18.5211C62.0046 8.29238 51.3929 3.38786 44.539 7.56658C37.6851 11.7453 37.1844 23.4248 43.4207 33.6536C49.657 43.8823 60.2687 48.7868 67.1226 44.6081Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M69.0462 43.0791C63.3413 48.9136 52.7928 46.0402 45.4949 36.6578C38.1933 27.2792 36.9052 14.9395 42.6139 9.10123C47.6709 3.92986 56.516 5.59522 63.5395 12.5539C64.4503 13.4533 65.3306 14.4441 66.169 15.5226C66.6492 16.1399 67.1027 16.7687 67.5257 17.409C73.604 26.4941 74.3815 37.6257 69.0462 43.0791Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5246 17.4019L63.0049 19.0444L58.6719 14.479L63.5384 12.5469C64.4492 13.4462 65.3295 14.4371 66.1679 15.5156C66.6481 16.1329 67.1016 16.7617 67.5246 17.4019Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3348 6.60938L43.7656 9.67714",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2086 7.69531L47.0625 10.5192",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7762 9.63281L50.207 12.7044",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.487 31.3906L62.9141 34.4622",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4676 35.1328L62.8984 38.2044",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5809 38.8906L62.0117 41.9622",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4851 12.6484L54.1484 15.7238",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5223 17.5078L57.9531 20.5794",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1226 44.6081C73.9765 40.4294 74.4772 28.7499 68.2409 18.5211C62.0046 8.29238 51.3929 3.38786 44.539 7.56658C37.6851 11.7453 37.1844 23.4248 43.4207 33.6536C49.657 43.8823 60.2687 48.7868 67.1226 44.6081Z",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9937 45.8347C71.8476 41.656 72.3483 29.9764 66.112 19.7477C59.8757 9.51894 49.264 4.61443 42.4101 8.79314C35.5562 12.9719 35.0555 24.6514 41.2918 34.8801C47.5281 45.1089 58.1398 50.0134 64.9937 45.8347Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2867 43.0267C69.102 39.4812 69.5253 29.5693 64.2324 20.8879C58.9394 12.2064 49.9344 8.04277 44.1192 11.5882C38.304 15.1337 37.8806 25.0456 43.1736 33.727C48.4666 42.4085 57.4715 46.5721 63.2867 43.0267Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M63.2867 43.0267C69.102 39.4812 69.5253 29.5693 64.2324 20.8879C58.9394 12.2064 49.9344 8.04277 44.1192 11.5882C38.304 15.1337 37.8806 25.0456 43.1736 33.727C48.4666 42.4085 57.4715 46.5721 63.2867 43.0267Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2867 43.0267C69.102 39.4812 69.5253 29.5693 64.2324 20.8879C58.9394 12.2064 49.9344 8.04277 44.1192 11.5882C38.304 15.1337 37.8806 25.0456 43.1736 33.727C48.4666 42.4085 57.4715 46.5721 63.2867 43.0267Z",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7881 35.6262C39.5916 27.6652 38.4979 17.1929 43.3415 12.2426C43.4978 12.0825 43.6578 11.9339 43.8217 11.7891C43.3492 12.1054 42.9033 12.4712 42.4879 12.898C37.6443 17.8522 38.738 28.3207 44.9307 36.2816C50.9252 43.9872 59.4997 46.5215 64.4386 42.1847C59.412 45.565 51.4473 42.9088 45.7881 35.6262Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3804 36.3786L51.3209 34.9991L50.4635 36.1309L49.4383 34.7971L50.2958 33.6653L49.1983 32.2362L48.3408 33.368L47.3157 32.0342L48.1731 30.9024L47.0375 29.4276C43.9659 25.43 43.0742 21.6648 46.2639 17.45C49.4536 13.2351 51.9955 14.4813 54.5221 17.7663L55.4176 18.9324L52.4185 22.8957L51.3209 21.4666C50.4597 20.3462 49.5298 19.1801 48.5695 20.4491C47.6091 21.7182 48.4399 23.0672 49.3355 24.2333L51.2943 26.779L53.0777 24.4239L54.1029 25.7577L52.3194 28.1128L53.4169 29.5419L55.2004 27.1868L56.2255 28.5206L54.442 30.8757L56.3094 33.3032C57.3155 34.6104 58.2758 35.4564 59.1828 34.256C60.0898 33.0555 59.2438 31.7751 58.3482 30.609L57.5784 29.6105L60.5776 25.6472L61.073 26.2912C63.5958 29.5762 64.6057 33.1813 61.5036 37.2818C58.3139 41.4928 55.3833 40.2848 52.3804 36.3824V36.3786Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4858 36.8524L50.4264 35.4729L49.5689 36.6047L48.5438 35.2709L49.4013 34.1391L48.3037 32.71L47.4463 33.8418L46.4212 32.508L47.2786 31.3762L46.143 29.9014C43.0714 25.9038 42.1796 22.1386 45.3693 17.9238C48.4371 13.869 51.1009 14.9551 53.6275 18.2401L54.5231 19.4062L51.5239 23.3695L50.4264 21.9404C49.5651 20.82 48.6353 19.6539 47.6749 20.9229C46.6993 22.2148 47.5454 23.541 48.4409 24.7071L50.3997 27.2528L52.1832 24.8977L53.2083 26.2315L51.4248 28.5866L52.5224 30.0157L54.3059 27.6606L55.331 28.9944L53.5475 31.3495L55.4148 33.777C56.4209 35.0842 57.3813 35.9302 58.2883 34.7298C59.2295 33.4836 58.3492 32.2489 57.4537 31.0828L56.6839 30.0843L59.683 26.121L60.1785 26.765C62.7013 30.05 63.7111 33.6551 60.6091 37.7556C57.507 41.8561 54.4888 40.7586 51.4858 36.8562V36.8524Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.381089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Sur3);
export default __webpack_public_path__ + "static/media/2sur3.03aec616d2fe487f1b2f4076974972be.svg";
export { ForwardRef as ReactComponent };